<!--
Copyright (c) 2022-2023 Antmicro <www.antmicro.com>

SPDX-License-Identifier: Apache-2.0
-->

<!-- eslint-disable max-len -->
<template>
    <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M1.89375 13.625C1.58438 13.625 1.31953 13.5148 1.09922 13.2945C0.878906 13.0742 0.76875 12.8094 0.76875 12.5V1.8125H0V0.6875H3.525V0.125H8.475V0.6875H12V1.8125H11.2313V12.5C11.2313 12.8 11.1188 13.0625 10.8938 13.2875C10.6688 13.5125 10.4063 13.625 10.1063 13.625H1.89375ZM10.1063 1.8125H1.89375V12.5H10.1063V1.8125ZM3.88125 10.8875H5.00625V3.40625H3.88125V10.8875ZM6.99375 10.8875H8.11875V3.40625H6.99375V10.8875Z"
            fill="#E5E5E5"
        />
    </svg>
</template>
